import React from "react";

import FormInputWidget from "./FormInputWidget";

const FormEmailWidget = props => <FormInputWidget {...props} type="email" />;

export default FormEmailWidget;
